import { getFieldErrorMessage } from '@avalara/bat-apps-shared/lib/form-validation';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { signupFormChanged, clearFieldForValidation } from '../../../store/shared-signup';
import { FieldErrorMessage, FormInput } from '../../../components/styled/components/sign-up';
import { isFieldVisitedAndInvalid } from '../../../lib/shared-signup';
import { updateProductAnalytics } from '../../../lib/side-effects/analytics';
import { getRegions } from '../../../lib/side-effects/avatax';
import { selectState } from '../../../selectors';
const FormInputComponent = ({ addPadding, fieldName, marginAboveError, maxLength, placeholder, type, validateDuringInput, width, }) => {
    var _a;
    const dispatch = useDispatch();
    const { sharedSignup, offer: { offerFlow } } = useSelector(selectState);
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const showPasswordError = queryParams.get('invalidPassword') === 'true' && fieldName === 'password';
    const fieldMissingOrInvalid = isFieldVisitedAndInvalid(sharedSignup, fieldName) || showPasswordError;
    const value = sharedSignup.signupForm[fieldName] || '';
    const disabled = sharedSignup.disableForm || false;
    const readOnly = !!((_a = sharedSignup.readOnlyFields) === null || _a === void 0 ? void 0 : _a.includes(fieldName));
    const handleFocus = () => {
        var _a, _b;
        if (validateDuringInput)
            dispatch(clearFieldForValidation(fieldName));
        if (showPasswordError) {
            queryParams.delete('invalidPassword');
            history.replace({
                search: queryParams.toString(),
            });
        }
        const { digitalData } = window;
        if (!digitalData)
            return;
        const eventType = (_b = (_a = digitalData.event) === null || _a === void 0 ? void 0 : _a.eventInfo) === null || _b === void 0 ? void 0 : _b.eventType;
        if (value === '' && eventType !== 'Account Form Start') {
            dispatch(updateProductAnalytics('account_start', !!offerFlow));
        }
    };
    const handleInput = (event) => {
        if (type !== 'number' || !maxLength)
            return;
        if (event.currentTarget.value.length > maxLength) {
            event.currentTarget.value = event.currentTarget.value.slice(0, maxLength);
        }
    };
    const onFormChanged = (event) => {
        let { value: changedValue } = event.target;
        if (fieldName === 'phone') {
            changedValue = changedValue.replace(/[^0-9]/gi, '');
        }
        dispatch(signupFormChanged({ field: fieldName, value: changedValue }));
        if (fieldName === 'country')
            dispatch(getRegions(changedValue));
    };
    return React.createElement(React.Fragment, null,
        React.createElement(FormInput, { disabled: disabled, type: type || 'text', value: value, name: fieldName, id: fieldName, onInput: handleInput, maxLength: maxLength, isInvalid: fieldMissingOrInvalid, readOnly: readOnly, onBlur: () => dispatch(clearFieldForValidation(fieldName)), onFocus: handleFocus, onChange: onFormChanged, placeholder: placeholder, width: width, marginAboveError: marginAboveError !== null && marginAboveError !== void 0 ? marginAboveError : '' }),
        fieldMissingOrInvalid &&
            React.createElement(FieldErrorMessage, { className: `field-error-message${addPadding ? ' margin-all-none' : ''}` },
                React.createElement("p", null, getFieldErrorMessage(fieldName, value))));
};
export default FormInputComponent;
